import React from "react";
import { Redirect } from "react-router-dom";

// Layout Types
import { DefaultLayout, CustomLayout } from "./layouts";

// Authentication Components
import Login from './components/authentication/Login';
import UpdateProfile from './components/authentication/UpdateProfile';
import ForgotPassword from './components/authentication/ForgotPassword';

// Route Views
import Z21Overview from "./views/Z21Overview";
import FacebookData from "./views/FacebookData";
import KlaviyoData from "./views/KlayivoData";
import PastReports from "./views/PastReports";
import AdminDashboard from './views/AdminDashboard';
import AdminReportsOverview from './views/AdminReportsOverview'
import AdminUpdateUsers from './views/AdminUpdateUsers'
import Errors from './views/Errors'


export default [
  {
    path: "/",
    exact: true,
    layout: DefaultLayout,
    component: () => <Redirect to="/login" />
  },
  {
    path:"/login",
    layout:CustomLayout,
    component: Login
  },
  {
    path:"/forgot-password",
    layout:CustomLayout,
    component: ForgotPassword
  },
  { 
    path:"/update-profile",
    layout:CustomLayout,
    component: UpdateProfile
  },
  {
    path: "/overview",
    layout: DefaultLayout,
    component: Z21Overview
  },
  {
    path:"/admin",
    layout:DefaultLayout,
    component: AdminDashboard
  },
  {
    path:"/update-users",
    layout:DefaultLayout,
    component: AdminUpdateUsers
  },
  {
    path:"/admin-reports",
    layout:DefaultLayout,
    component: AdminReportsOverview
  },
  {
    path: "/facebook-data",
    layout: DefaultLayout,
    component: FacebookData
  },
  {
    path: "/klaviyo-data",
    layout: DefaultLayout,
    component: KlaviyoData
  },
  {
    path: "/past-reports",
    layout: DefaultLayout,
    component: PastReports
  },
  {
    path:"/404",
    layout:CustomLayout,
    component: Errors
  },
  {
    path:"*",
    layout:CustomLayout,
    component: Errors
  }

];
